import {
  ACTIVE_BONUSES_KEY,
  BONUS_COST_KEY,
  BONUS_PERCENT_KEY,
  CASH_MACHINE_KEY,
  CUSTOMER_KEY,
  FISCAL_ID_KEY,
  ID_KEY,
  MONEY_COST_KEY,
  PENDING_BONUSES_KEY,
  REFUND_BONUS_COST,
  REFUND_MONEY_COST,
  STATUS_KEY,
  STORE_NAME_KEY,
  TIMESTAMP_KEY,
  TOTAL_COST_KEY,
  USER_LEVEL_KEY,
} from '@esentai/core/features/purchases/consts/keys';
import { TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

import CondenseTableCell from '@/components/CondenseTableCell';
import CanView from '@/containers/CanView';
import { isMallStaff } from '@/features/currentUser/selectors';

const HeadRow = ({ SortControl }) => (
  <TableRow>
    <CondenseTableCell>
      <SortControl field={ID_KEY}>ID</SortControl>
    </CondenseTableCell>

    <CanView permission={isMallStaff}>
      <CondenseTableCell>
        <SortControl field={CUSTOMER_KEY}>ID покупателя</SortControl>
      </CondenseTableCell>
    </CanView>

    <CondenseTableCell>
      <SortControl field={USER_LEVEL_KEY}>Уровень лояльности</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={CASH_MACHINE_KEY}>Номер ККМ</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={FISCAL_ID_KEY}>UUID</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={STORE_NAME_KEY}>Магазин</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={TIMESTAMP_KEY}>Дата и время покупки</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={TOTAL_COST_KEY}>Общая сумма чека</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={BONUS_PERCENT_KEY}>
        Процент начисления бонусов
      </SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={PENDING_BONUSES_KEY}>
        Сумма бонусов к начислению
      </SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={ACTIVE_BONUSES_KEY}>
        Сумма начисленных бонусов
      </SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={STATUS_KEY}>Способ оплаты</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={BONUS_COST_KEY}>Оплата бонусами</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={MONEY_COST_KEY}>Оплата деньгами</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={REFUND_BONUS_COST}>Возврат бонусов</SortControl>
    </CondenseTableCell>

    <CondenseTableCell>
      <SortControl field={REFUND_MONEY_COST}>Возврат денег</SortControl>
    </CondenseTableCell>
  </TableRow>
);

HeadRow.propTypes = {
  SortControl: PropTypes.func.isRequired,
};

export default HeadRow;
